var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.343,
    height: 21.343,
    viewBox: "0 0 21.343 21.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1101",
    d: "M21.343-682.665H0v21.343H21.343Z",
    transform: "translate(0 682.665)",
    fill: "#232323"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1095",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1097",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1099",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1105",
    transform: "translate(0.834 0.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1107",
    d: "M19.676-206.663,10.8-213.03a1.659,1.659,0,0,0-.959-.3,1.659,1.659,0,0,0-.959.3L0-206.663",
    transform: "translate(0 213.333)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1109",
    transform: "translate(2.501 5.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1111",
    d: "M-284.782-9.385a1.66,1.66,0,0,1,.959-.3,1.66,1.66,0,0,1,.959.3l6.5,4.7a1.667,1.667,0,0,1,.708,1.364V4.152a1.667,1.667,0,0,1-1.667,1.667h-4.835V2.484A1.667,1.667,0,0,0-283.824.817a1.667,1.667,0,0,0-1.667,1.667V5.819h-4.835a1.667,1.667,0,0,1-1.667-1.667V-3.326a1.667,1.667,0,0,1,.708-1.364Z",
    transform: "translate(291.994 9.688)",
    fill: "none",
    stroke: "#232323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.7e7d45a1551a30d91d9fe3ba9d2d8e43.svg";
export { ForwardRef as ReactComponent };